module.exports = "<div [@fadein]=\"stateAnimation\">\n  <p>\n    <span>{{message}}</span>\n  </p>\n</div>\n"